import { html, LitElement, css, unsafeCSS } from 'lit';

import '../components/comments';
import '../parts/event';
import '../parts/monster';
import '../parts/status';

import style from './list.scss';
import { DATA_EVENTS, DATA_MONSTERS, DATA_STATUS } from '../data/sources';
import { setTitle, trackPage } from '../shared/utils';

export class ListPage extends LitElement {

    static get properties() {
        return {
        }
    }

    constructor() {
        super();        
        this.type = '';     
    }

    static styles = css`
        ${unsafeCSS(style)}        
    `;

    connectedCallback() {
        super.connectedCallback();
        trackPage();
        this.type = location.pathname.split('/')[1];       
        setTitle(this.type.substring(0,1).toUpperCase()+this.type.substring(1));
    }

    render() {                       
        return html`
            ${this.type === 'events' ? html`
                <h1>Events</h1>
                ${DATA_EVENTS.map(val=>{
                    return html`
                        <div class="row">
                            <event-part id="${val.name}"></event-part>
                        </div>
                    `;
                })}
            `:''}
            ${this.type === 'monsters' ? html`
                <h1>Monsters</h1>
                ${DATA_MONSTERS.map(val=>{
                    return html`
                        <div class="row">
                            <monster-part id="${val.name}"></monster-part>
                        </div>
                    `;
                })}
            `:''}
            ${this.type === 'status' ? html`
                <h1>Status</h1>
                ${DATA_STATUS.map(val=>{
                    return html`
                        <div class="row">
                            <status-part id="${val.name}"></status-part>
                        </div>
                    `;
                })}
            `:''}
            <comments-component path=${window.location.pathname}></comments-component>
        `;
    }
}

customElements.define('list-page', ListPage);